'use strict'

export const TriangleOptions = {
  colors: [],
  hankei: [2, 8],
  canvasNoClear: false
}

export default class TriangleClass {
  /**
   * @param {DomElement} el
   * @param {Object} options
   */
  constructor(el, options) {
    this.options = Object.assign({}, TriangleOptions, options)

    this.canvas = el
    this.ctx = this.canvas.getContext('2d')

    const width = this.canvas.getBoundingClientRect().width
    const height = this.canvas.getBoundingClientRect().height
    this.w = this.canvas.width = width * 2
    this.h = this.canvas.height = height * 2

    this.triangleScreenLength = 5
    this.triangleScreen = this.createScreen()
    this.init()
  }

  /**
   * 指定数スクリーンを作成する
   */
  createScreen() {
    let array = []
    for (let i = 0; i < this.triangleScreenLength; i++) {
      array.push(this.generateTriangleGrid(i))
    }
    return array
  }

  /**
   * スクリーン再生成
   *
   * @param {Number} index
   */
  reCreateScreen(index = 0) {
    this.triangleScreen[index] = this.generateTriangleGrid()
  }

  generateTriangleGrid(screenIndex = 0) {
    // 幅分割サイズ
    const hankei = (Array.isArray(this.options.hankei)) ? rand(this.options.hankei[0], this.options.hankei[1]) : Number(this.options.hankei)

    const cellWidth = Math.max(this.w, this.h) / hankei
    const cellHeight = Math.max(this.w, this.h) / hankei

    const columns = Math.ceil(this.w / cellWidth)
    const rows = Math.ceil(this.h / cellHeight)

    let screen = []
    for (let colIndex = 0; colIndex < columns; colIndex++) {
      for (let rowIndex = 0; rowIndex < rows; rowIndex++) {
        screen.push({
          col: colIndex,
          row: rowIndex,
          cellWidth: cellWidth,
          cellHeight: cellHeight,
          pattern: 1,
          // pattern: rand(0, 3),
          transformZ: 0,
          color: hex2rgb(randArray(this.options.colors))
        })
      }
    }
    return randArrayGetArray(screen, screen.length / 8)
  }

  renderTriangle() {
    if (!this.options.canvasNoClear) {
      this.ctx.clearRect(0, 0, this.w, this.h)
    }

    for (let screenIndex = 0; screenIndex < this.triangleScreen.length; screenIndex++) {
      const screen = this.triangleScreen[screenIndex]
      for (let cell of screen) {
        this.ctx.beginPath()

        if (cell.pattern === 0) {
          this.ctx.moveTo(cell.col * cell.cellWidth - cell.transformZ, cell.row * cell.cellHeight - cell.transformZ)
          this.ctx.lineTo(cell.col * cell.cellWidth + cell.cellWidth - cell.transformZ, cell.row * cell.cellHeight - cell.transformZ)
          this.ctx.lineTo(cell.col * cell.cellWidth - cell.transformZ, cell.row * cell.cellHeight + cell.cellHeight - cell.transformZ)
        } else if (cell.pattern === 1) {
          this.ctx.moveTo(cell.col * cell.cellWidth + cell.cellWidth - cell.transformZ, cell.row * cell.cellHeight - cell.transformZ)
          this.ctx.lineTo(cell.col * cell.cellWidth + cell.cellWidth - cell.transformZ, cell.row * cell.cellHeight + cell.cellHeight - cell.transformZ)
          this.ctx.lineTo(cell.col * cell.cellWidth - cell.transformZ, cell.row * cell.cellHeight - cell.transformZ)
        } else if (cell.pattern === 2) {
          this.ctx.moveTo(cell.col * cell.cellWidth + cell.cellWidth + cell.transformZ, cell.row * cell.cellHeight + cell.cellHeight + cell.transformZ)
          this.ctx.lineTo(cell.col * cell.cellWidth + cell.transformZ, cell.row * cell.cellHeight + cell.cellHeight + cell.transformZ)
          this.ctx.lineTo(cell.col * cell.cellWidth + cell.cellWidth + cell.transformZ, cell.row * cell.cellHeight + cell.transformZ)
        } else {
          this.ctx.moveTo(cell.col * cell.cellWidth + cell.transformZ, cell.row * cell.cellHeight + cell.cellHeight + cell.transformZ)
          this.ctx.lineTo(cell.col * cell.cellWidth + cell.transformZ, cell.row * cell.cellHeight + cell.transformZ)
          this.ctx.lineTo(cell.col * cell.cellWidth + cell.cellWidth + cell.transformZ, cell.row * cell.cellHeight + cell.cellHeight + cell.transformZ)
        }

        this.ctx.fillStyle = `rgb(${cell.color[0]},${cell.color[1]},${cell.color[2]})`
        this.ctx.closePath()
        this.ctx.fill()
      }
    }
  }

  init() {
    this.renderTriangle()
  }

  reGenerate() {
    this.renderTriangle()
  }
}

/**
 * rand - ランダムに値を取得する
 * @param {Number} min - 1
 * @param {Number} max - 2
 * @return {Number} 1.5
 */
const rand = (min, max) => {
  return Math.floor((Math.random() * (max - min + 1)) + min)
}

/**
 * randAry
 * 配列内からランダムに値を取得する
 * @param {array} iAry 配列
 * @return {object} 配列内の値
 */
const randArray = (iAry) => {
  // 添字を全て取得
  const aryKeys = Object.keys(iAry)
  // 対象の添字をランダムに取得
  const index = aryKeys[Math.floor(Math.random() * aryKeys.length)]
  return iAry[index]
}

function randArrayGetArray(arr2 = [], count) {
  let arr = [].concat(arr2)
  let randArr = []
  let rand
  /* eslint-disable */
  for(let i = 0, len = arr.length; i < count; i++, len--) {
  /* eslint-enable */
    rand = Math.floor(Math.random() * len) // 0～len-1の範囲の整数からランダムに値を取得
    randArr.push(arr.splice(rand, 1)[0]) // 配列のランダム値に対応するインデックスを得たうえで元々の配列から取り除く
  }
  return randArr
}

// https://lab.syncer.jp/Web/JavaScript/Snippet/61/
function hex2rgb(hex) {
  if (hex.slice(0, 1) === '#') {
    hex = hex.slice(1)
  }
  if (hex.length === 3) {
    hex = hex.slice(0, 1) + hex.slice(0, 1) + hex.slice(1, 2) + hex.slice(1, 2) + hex.slice(2, 3) + hex.slice(2, 3)
  }
  return [hex.slice(0, 2), hex.slice(2, 4), hex.slice(4, 6)].map((str) => parseInt(str, 16))
}
